import { ImgHTMLAttributes } from 'react';
import { MediaImage } from '../../components/skeleton/MediaImage';
import type { PublicImage } from './publicImageTypes';

export type { PublicImage, PublicImageAsset } from './publicImageTypes';

interface ResponsiveImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'sizes'> {
  image?: PublicImage | null;
  fallbackSrc: string;
  sizes: string;
}

export function ResponsiveImage({ image, fallbackSrc, sizes, loading = 'lazy', decoding = 'async', ...props }: ResponsiveImageProps) {
  const variants = image?.variants.filter((variant) => variant.mime === 'image/webp' && variant.width > 0) ?? [];
  const sortedVariants = [...variants].sort((left, right) => left.width - right.width);
  const defaultVariant = sortedVariants.find((variant) => variant.width >= 480) ?? sortedVariants[sortedVariants.length - 1];
  const src = defaultVariant?.url ?? fallbackSrc;
  const srcSet = sortedVariants.length > 0
    ? sortedVariants.map((variant) => `${variant.url} ${variant.width}w`).join(', ')
    : undefined;

  return <MediaImage {...props} src={src} srcSet={srcSet} sizes={srcSet ? (loading === 'lazy' ? `auto, ${sizes}` : sizes) : undefined} loading={loading} decoding={decoding} />;
}
